import { categories } from "@/mocks/categories";
import { allArticles } from "@/mocks/articles";

const guideLinks = allArticles.slice(0, 6);

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Categories
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              More Categories
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2.5">
              {categories.slice(7, 14).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Guides
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2.5">
              <Link
                to="/acbuyspreadsheet-guide"
                className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                Complete Guide 2026
              </Link>
              {guideLinks.slice(1, 5).map((article) => (
                <Link
                  key={article.slug}
                  to={`/guide/${article.slug}`}
                  className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  {article.title.split(":")[0].split(" (")[0]}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
              Info
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="space-y-2.5">
              <Link
                to="/"
                className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                Home
              </Link>
              <Link
                to="/acbuyspreadsheet-guide"
                className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                Shopping Guide
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                ACBuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                Main Site
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              ACBuy<span className="font-light">Spreadsheet</span>
            </p>
            <div className="w-12 h-px bg-accent-500 mt-2 mb-3"></div>
            <p className="text-xs text-foreground-500">
              Your Trusted Order Tracking Wiki
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors"
            >
              <i className="ri-shopping-cart-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors"
            >
              <i className="ri-store-2-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors"
            >
              <i className="ri-global-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} ACBuySpreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            External links open on kaspreadsheet.com
          </p>
        </div>
      </div>
    </footer>
  );
}